import { useState } from 'react';
import styled from 'styled-components';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useBroadcastContext } from '../contexts/BroadcastContext.jsx';
import { AutoSave } from '../../../shared/TileActionMenu/AutoSave.jsx';
import Button, { ButtonBase } from '../../../shared/Button';

import { useDeleteBroadcastMessageMutation } from '../hooks/useBroadcastMessagesMutation';
import { navigateBack } from '../utils/navigation';

import { ConfirmationModal } from '../components/ConfirmationModal';

export const HeaderContainer = () => {
  const { t } = useTranslation('broadcasts');
  const history = useHistory();
  const location = useLocation();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const { autoSaved, dirty, values, saveAndCloseDraft } = useBroadcastContext();
  const {
    deleteBroadcastMessageMutation,
    isLoading,
  } = useDeleteBroadcastMessageMutation();

  const handleClick = () => {
    if (!dirty) {
      navigateBack(history, location);
      return;
    }

    return saveAndCloseDraft();
  };

  return (
    <>
      <ConfirmationModal
        header={t('deleteConfirmationModal.header')}
        body={t('deleteConfirmationModal.body')}
        cancelText={t('deleteConfirmationModal.cancel')}
        submitText={t('deleteConfirmationModal.submit')}
        open={openDeleteModal}
        variant="error"
        onClose={() => setOpenDeleteModal(false)}
        onSave={() => deleteBroadcastMessageMutation({ id: values.uuid })}
      />
      <LeftSide>
        <Button
          onClick={handleClick}
          mode="text"
          variant="black"
          data-testid="broadcast-back-link"
        >
          <BackArrow className="fa-solid fa-chevron-left" />
          {t('backLink')}
        </Button>
        <AutoSave autoSaved={autoSaved} />
      </LeftSide>

      {values.uuid && (
        <RightSide>
          <DeleteBtn
            disabled={isLoading}
            onClick={() => setOpenDeleteModal(true)}
            mode="text"
            variant="black"
          >
            <TrashIcon /> {t('deleteDraft')}
          </DeleteBtn>
        </RightSide>
      )}
    </>
  );
};

const BackArrow = styled.i`
  margin-right: 10px;
`;

const TrashIcon = styled.i.attrs({
  className: 'fa-light fa-trash',
})`
  margin-right: 4px;
`;

const LeftSide = styled.div`
  display: flex;
  align-items: center;
`;

const RightSide = styled.div``;

const DeleteBtn = styled(ButtonBase)``;
